import { Panel } from "primereact/panel";
import { TextField } from "../../../components/TextField";
import { useTranslation } from "react-i18next";


 
 
 
export const ReceitaFederal = ({receitaFederal}: {receitaFederal: any}) => {
  const { t } = useTranslation();
  const getValue = (value?: string): string => value || "Não informado";
  receitaFederal = receitaFederal.data[0]
  return (
    <div>
      <Panel header={t('receitaFederal')}>
        {receitaFederal.erro ? (<p>{receitaFederal.erro}</p>):(<div>
        
          <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
            <div>
              <TextField
                label="Documento"
                value={getValue(receitaFederal.cpf)}
              />
             <TextField
                label="Comprovante"
                value={getValue(receitaFederal.consulta_comprovante)}
              />
             <TextField
                label="Data nascimento"
                value={getValue(receitaFederal.data_nascimento)}
              />
            <TextField
                label="Nome civíl"
                value={getValue(receitaFederal.nome_civil)}
              />
            <TextField
                label="Ano Óbto"
                value={getValue(receitaFederal.ano_obito)}
              />
            </div>
            <div>
              <TextField
                label="Nome"
                value={getValue(receitaFederal?.nome)}
              />
              <TextField
                label="Data Consulta"
                value={getValue(receitaFederal.consulta_datahora)}
              />
               <TextField
                    label="Data inscrição"
                    value={getValue(receitaFederal.normalizado_data_inscricao)}/>
                <TextField
                    label="Nome Social"
                    value={getValue(receitaFederal.nome_social)}
                />
            </div>
          </section>
        </div>)} 
      </Panel>
      
    </div>
  );
};